export default __webpack_public_path__ + "static/blog12-deaa52f1a8aa6d1140ec9deac510b8d4.jpg";